/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OtherBuildingEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export const OtherBuildingEnum = {
    NUMBER_1: 1 as OtherBuildingEnum,
    NUMBER_2: 2 as OtherBuildingEnum,
    NUMBER_3: 3 as OtherBuildingEnum,
    NUMBER_4: 4 as OtherBuildingEnum,
    NUMBER_5: 5 as OtherBuildingEnum,
    NUMBER_6: 6 as OtherBuildingEnum,
    NUMBER_7: 7 as OtherBuildingEnum,
    NUMBER_8: 8 as OtherBuildingEnum,
    NUMBER_9: 9 as OtherBuildingEnum,
    NUMBER_10: 10 as OtherBuildingEnum
};

